import React from 'react'

import { ColSettings } from './ColSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'

import { useNode } from 'react-pagebuilder/hooks/useNode'

export const defaultProps = {
  width: '50',
}

export const dynamicProps = []

export const Col: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }
    const { width } = blockProps

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-col${width ? ` block-col--${width}` : ''} ` + props.className}
      >
        {React.Children.toArray(children).filter((child) => !child.props.hidden)}
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

Col.craft = withCraft({
  name: 'Column',
  defaultProps: defaultProps,
  settings: ColSettings,
})
